import { Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { Category, HighlightedServices } from 'src/app/models/searchresult.model';
import { DrupalService } from 'src/app/services/drupal.service';
import { SearchServiceService } from 'src/app/services/search-service.service';
import { getThumbnail, stringSubstr } from 'src/app/utils.ts/helpers';

@Component({
  selector: 'app-service-list-loader',
  templateUrl: './service_list_loader.component.html',
  styleUrls: ['./service_list_loader.component.scss']
})
export class ServiceListLoaderComponent implements OnInit {

  constructor(private drupalService: DrupalService) { }

  searchServiceService = inject(SearchServiceService);
  allServices = this.searchServiceService.allServices;
  serviceLength: number = 0
  searchResults = this.searchServiceService.searchResults;


  @Input() data: any;
  @ViewChild('top') scrollToTop: ElementRef | undefined;

  allNews: any[] = [];
  isLoading: boolean = true;
  paginatorVisible: boolean = true;
  inEvidenza: HighlightedServices[] = [];
  categories: Category[] = [];
  totalServices: number = 0;

  getThumbnail = getThumbnail;
  stringSubstr = stringSubstr

  ngOnInit(): void {
    this.data.service_list_loader_services = Array.isArray(this.data.service_list_loader_services) ? this.data.service_list_loader_services.filter((service: any) => service.status === true && service.moderation_state !== 'archived') : [];
   this.searchServiceService.totalLength.subscribe((total: number) => {
      this.totalServices = total;
    });
    this.inEvidenza = this.data?.service_list_loader_services?.map((service: any) => ({
      title: service.title,
      path: service.path?.alias || ''
    })) || [];
    this.categories = this.data?.service_list_loader_categories?.map((category: any) => ({
      title: category.title,
      description: category.description,
      path: category.alias || ''
    })) || [];

    if (this.allServices().length > 0) return;
    this.searchServiceService.getAllServices();

  }

  search(searchTerm: string, newTerm: boolean = false) {
    if (!searchTerm.trim()) {
      this.searchServiceService.alreadySearched = false;
      this.searchServiceService.cleanResults();
      this.searchServiceService.getAllServices();
      return;
    }
    if (newTerm) this.searchServiceService.cleanResults();
    this.searchServiceService.search(searchTerm);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      localStorage.removeItem('totalLength');
    })
  }

}
